"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookies = exports.getCookieFromString = exports.getCookiesFromString = void 0;
/**
 * Get a cookies object from the string found in document.cookie (also the
 * same as `Cookie` header strings).
 *
 * Adapted from http://stackoverflow.com/questions/10730362/get-cookie-by-name
 */
function getCookiesFromString(cookiesString) {
    return cookiesString.split(';').reduce((acc, cookieString) => {
        const parts = cookieString.split('=');
        if (parts.length > 1) {
            acc[parts[0].trim()] = parts.slice(1).join('').trim();
        }
        return acc;
    }, {});
}
exports.getCookiesFromString = getCookiesFromString;
/**
 * Given a browser cookies string and the name of a cookie, returns the
 * corresponding cookie value, or `undefined` if the cookie was not present.
 */
function getCookieFromString(cookieName, cookiesString) {
    return getCookiesFromString(cookiesString)[cookieName];
}
exports.getCookieFromString = getCookieFromString;
const COOKIE_SOURCES = [
    function getFromConfig(context) {
        var _a, _b;
        return (_b = (_a = context.config) === null || _a === void 0 ? void 0 : _a.getCookies) === null || _b === void 0 ? void 0 : _b.call(_a, context);
    },
    function getFromServerRequest(context) {
        var _a;
        return (_a = context.serverRequest) === null || _a === void 0 ? void 0 : _a.cookies;
    },
    function getFromBrowserCookies() {
        // Safe access to window.document.cookie if it's available.
        if (typeof window !== 'undefined' && window.document) {
            return getCookiesFromString(window.document.cookie);
        }
        return undefined;
    },
];
/**
 * Calls each function in COOKIE_SOURCES in order until one of them returns a
 * truthy value. Returns the resolved cookies or an empty object if none of the
 * cookie sources returned a value.
 *
 * The primary motivation for this abstraction is to allow an application
 * running in a React Native environment to provide cookies from the
 * underlying iOS and Android systems.
 */
function getCookies(context) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let i = 0; i < COOKIE_SOURCES.length; i += 1) {
            const maybePromise = COOKIE_SOURCES[i](context);
            if (maybePromise) {
                // eslint-disable-next-line no-await-in-loop
                const resolvedCookies = yield maybePromise;
                // If the promise resolves to a falsy value assume no cookies (and not
                // an indication to use the approach)
                return resolvedCookies || {};
            }
        }
        // No cookies available
        return {};
    });
}
exports.getCookies = getCookies;
